/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1170
 */

var r = require(/* 2474 */"./2474")
var i = require(/* 1172 */"../../../../../../797/101/2538/2539/2540/2554/1172")
var o = require(/* 1173 */"../../../../../../797/101/2538/2539/2540/2554/1173")
var a = o && o.isTypedArray
var s = a ? i(a) : r
module.exports = s
